import { arrayOf, func } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Loading from '../../generic/Loading';
import { productShape } from '../../prop-types';
import { fetchProducts } from '../actions';

export default function withProducts({ removeDeprecatedProducts }) {
  return Component => {
    class ComponentWithProducts extends React.Component {
      componentDidMount() {
        this.props.fetchProducts();
      }

      render() {
        const { products } = this.props;
        if (!products.length) {
          return <Loading />;
        }
        const props = {
          ...this.props,
          products: removeDeprecatedProducts
            ? products.filter(p => !p.deprecated)
            : products,
        };
        return <Component {...props} />;
      }
    }

    ComponentWithProducts.propTypes = {
      products: arrayOf(productShape.isRequired).isRequired,
      fetchProducts: func.isRequired,
    };

    const ConnectedComponentWithProducts = connect(
      ({ products }) => ({ products }),
      { fetchProducts },
    )(ComponentWithProducts);

    ConnectedComponentWithProducts.displayName = `withProducts(${
      Component.displayName || Component.name
    })`;

    return ConnectedComponentWithProducts;
  };
}
